if (!customElements.get('product-availability')) {

    class ProductAvailability extends HTMLElement {
        constructor() {
            super();
            
            this.drawer       = this.querySelector('.availability-drawer');
            this.closeButton  = this.drawer.querySelector('.drawer__close');
            this.trigger      = document.querySelector('.availability-drawer-button');

            this.listeners();

        }

        open() {
            document.body.classList.add('hidden');
            this.drawer.classList.add('active');
            this.closeButton.addEventListener('click', this.close.bind(this));
        }

        close() {
            document.body.classList.remove('hidden');
            this.drawer.classList.remove('active');
        }

        listeners() {
            if (this.trigger) {
                this.trigger.addEventListener('click', this.open.bind(this));
            }

            if (this.drawer) {
                this.drawer.addEventListener('click', (event) => {
                    if ( !event.target.closest('.product-availability-drawer') ) {
                        this.close();
                    }
                });

                const variantsContainer = this.drawer.querySelector('.availability-drawer__variants');
                const storesContainer = this.drawer.querySelector('.availability-drawer__stores');

                if (variantsContainer && storesContainer) {
                    const checkboxes = variantsContainer.querySelectorAll('input[type="checkbox"]');

                    const updateStoreItemsFor = (checkbox) => {
                        const val = checkbox.value;
                        const items = storesContainer.querySelectorAll(`li[data-variant-id="${CSS.escape(val)}"]`);
                        items.forEach((li) => {
                            if (checkbox.checked) {
                                li.classList.add('active');
                            } else {
                                li.classList.remove('active');
                            } 
                        });

                        const checkedItems = storesContainer.querySelectorAll('li.active');
                        if ( checkedItems.length > 0 ) {
                            storesContainer.classList.add('is-active');
                        } else {
                            storesContainer.classList.remove('is-active');
                        }

                    };

                    checkboxes.forEach((cb) => {
                        cb.addEventListener('change', () => updateStoreItemsFor(cb));
                        // initialize state
                        updateStoreItemsFor(cb);
                    });
                }

            }

        }

    }
        
    customElements.define('product-availability', ProductAvailability);
}
  